App.factory('fileDownload', FileDownload);
function FileDownload($http,FileSaver, Blob) {
    var serviceObj = {};
    serviceObj.get = Get;
    function Get(fileUrl,filename) {
        $http({
            method: 'GET',
            url: fileUrl,
            responseType: 'arraybuffer'
        }).success(function (data, status, headers) {
            headers = headers();
            //var filename = headers['x-filename'];
            var contentType = headers['content-type'];

            //var linkElement = document.createElement('a');
            try {
                var blob = new Blob([data], {type: contentType});
                FileSaver.saveAs(blob, filename);
                //var url = window.URL.createObjectURL(blob);
                //
                //linkElement.setAttribute('href', url);
                //linkElement.setAttribute("download", filename);
                //linkElement.setAttribute("target", '_blank');
                //
                //var clickEvent = new MouseEvent("click", {
                //    "view": window,
                //    "bubbles": true,
                //    "cancelable": false
                //});
                //linkElement.dispatchEvent(clickEvent);
            } catch (ex) {
                console.log(ex);
            }
        }).error(function (data) {
            console.log(data);
        });
    }

    return serviceObj;
}